/**
 * The currently supported keyboard movement key combinations that increment or
 * decrement within a list. This was extracted from the w3.org website about
 * wia-aria best practices.
 *
 * @see https://www.w3.org/TR/wai-aria-practices/
 */
export var IncrementMovementKey;
(function (IncrementMovementKey) {
    IncrementMovementKey["ArrowUp"] = "ArrowUp";
    IncrementMovementKey["ArrowDown"] = "ArrowDown";
    IncrementMovementKey["ArrowLeft"] = "ArrowLeft";
    IncrementMovementKey["ArrowRight"] = "ArrowRight";
    IncrementMovementKey["PageDown"] = "PageDown";
    IncrementMovementKey["PageUp"] = "PageUp";
    IncrementMovementKey["ShiftArrowUp"] = "Shift+ArrowUp";
    IncrementMovementKey["ShiftArrowDown"] = "Shift+ArrowDown";
    IncrementMovementKey["ShiftArrowLeft"] = "Shift+ArrowLeft";
    IncrementMovementKey["ShiftArrowRight"] = "Shift+ArrowRight";
    IncrementMovementKey["AltArrowDown"] = "Alt+ArrowDown";
    IncrementMovementKey["AltArrowUp"] = "Alt+ArrowUp";
    IncrementMovementKey["AltArrowLeft"] = "Alt+ArrowLeft";
    IncrementMovementKey["AltArrowRight"] = "Alt+ArrowRight";
    IncrementMovementKey["AltPageDown"] = "Alt+PageDown";
    IncrementMovementKey["AltPageUp"] = "Alt+PageUp";
    IncrementMovementKey["ControlArrowDown"] = "Control+ArrowDown";
    IncrementMovementKey["ControlArrowUp"] = "Control+ArrowUp";
})(IncrementMovementKey || (IncrementMovementKey = {}));
/**
 * The currently supported keyboard movement key combinations that jump to the
 * start or end of a list.  This was extracted from the w3.org website about
 * wai-aria best practices.
 *
 * @see https://www.w3.org/TR/wai-aria-practices/
 */
export var JumpMovementKey;
(function (JumpMovementKey) {
    JumpMovementKey["Home"] = "Home";
    JumpMovementKey["End"] = "End";
    JumpMovementKey["AltHome"] = "Alt+Home";
    JumpMovementKey["AltEnd"] = "Alt+End";
    JumpMovementKey["ControlHome"] = "Control+Home";
    JumpMovementKey["ControlEnd"] = "Control+End";
    JumpMovementKey["ControlShiftHome"] = "Control+Shift+Home";
    JumpMovementKey["ControlShiftEnd"] = "Control+Shift+End";
})(JumpMovementKey || (JumpMovementKey = {}));
//# sourceMappingURL=types.js.map